<template>
  <div class="calendar-home">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>

    <div class="c-tabs">
      <router-link class="c-tab" to="/calendar/group-overview">Gruppe oversigt</router-link>
      <router-link class="c-tab" to="/calendar/my-calendar">Min kalender</router-link>
    </div>

    <div class="admin-panel">
      <employee-selector
        placeholder="Vis som..."
        @selection-changed="viewAs"
        :currentUser="currentUser"
        :showAll="true"
      >
      </employee-selector>
    </div>

    <div>
      <router-view
        @onUpdated="onUpdated"
        @onSplit="onSplit"
        @loadMore="loadMore"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import EmployeeSelector from "../scheduler/schedule/controls/EmployeeSelector.vue";
import APISTATE from "@/enums/APISTATE";

export default {
  components: { EmployeeSelector },
  data: () => ({
    fromDate: new Date(),
    toDaye: new Date(),
  }),
  name: "CalendarHome",
  async mounted() {
    const start = this.viewStartDate();
    const end = this.viewToDate();
    this.fromDate = start;
    this.toDate = end;

    const actions = [
      this.$store.dispatch("metadata/initialize"),
      this.employeesForMyCalendar(),
      this.getPeriods(start, end, null),
      this.getMyAllocations({
        startDate: start,
        endDate: end,
        asEmployee: this.viewAsEmployeeId,
      }),
    ];

    await Promise.all(actions);
  },
  methods: {
    ...mapActions("circles", ["getPeriods"]),
    ...mapActions("allocations", ["getMyAllocations", "updateAllocation"]),
    ...mapActions("employees", ["employeesForMyCalendar"]),
    ...mapActions("entrySidebar", ["entrySidebarOpen"]),
    ...mapActions(["setViewAs"]),
    viewStartDate() {
      return new Date();
    },
    viewToDate() {
      const start = this.viewStartDate();
      const toDate = moment(start)
        .add(4, "weeks")
        .toDate();
      return toDate;
    },
    async onUpdated() {
      const start = this.viewStartDate();
      const end = this.viewToDate();
      this.fromDate = start;
      this.toDate = end;
      await this.getMyAllocations({
        startDate: start,
        endDate: end,
        asEmployee: this.viewAsEmployeeId,
      });
    },
    async onSplit() {
      const start = this.viewStartDate();
      const end = this.viewToDate();
      this.fromDate = start;
      this.toDate = end;
      await this.getMyAllocations({
        startDate: start,
        endDate: end,
        asEmployee: this.viewAsEmployeeId,
      });
    },
    async viewAs(employeeAndGroup) {
      this.setViewAs(employeeAndGroup);
      await this.onUpdated();
    },
    async loadMore() {
      if (this.allocations && this.allocations.length > 0) {
        const allocation = this.allocations[this.allocations.length - 1];
        this.toDate = moment(allocation.calendarDate)
          .add(1, "days")
          .toDate();
      }
      this.fromDate = moment(this.toDate).toDate();
      this.toDate = moment(this.fromDate)
        .add(4, "weeks")
        .toDate();
      await this.getMyAllocations({
        startDate: this.fromDate,
        endDate: this.toDate,
        asEmployee: this.viewAsEmployeeId,
        isLoadingMore: true,
      });
    },
  },
  computed: {
    ...mapGetters([
      "viewAsEmployee",
      "isAdmin",
      "isReplacement",
      "currentUser",
    ]),
    ...mapGetters("allocations", [
      "allocationsApiState",
      "allocationApiState",
      "allocationsOnDateApiState",
      "allocations",
    ]),
    viewAsEmployeeId() {
      if (this.viewAsEmployee) {
        return this.viewAsEmployee.id;
      }
      return undefined;
    },
    isLoading() {
      return (
        this.allocationsApiState === APISTATE.LOADING ||
        this.allocationsOnDateApiState === APISTATE.LOADING ||
        this.allocationApiState === APISTATE.LOADING
      );
    },
  },
};
</script>

<style lang="scss">
.calendar-home {
  position: relative;

  .admin-panel {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #c9c8c8;
    padding: 1.25em;
    padding-bottom: 0;
  }
}
.c-tabs {
  display: flex;

  .c-tab {
    flex: 1;
    border-radius: 0px;
    font-size: 1rem;
    padding: 1.25em;
    color: white;
    background: rgb(162, 162, 162); // TODO: VARIABLE

    // From router-link
    &.is-active {
      background: $blue;
    }
  }
}

.viking-button {
  background: #0092cf;
  color: #ffffff;
}
@mixin calendar-entry-color {
  @each $color
    in (
      "timeoff",
      "blue",
      "danger",
      "orange",
      "green",
      "ivory",
      "red",
      "yellow"
    )
  {
    &.#{$color} {
      background-color: nth(map-get($colors, $color), 1);
      color: nth(map-get($colors, $color), 2);
    }
  }
}

.calendar-entry {
  @include calendar-entry-color;
  border-radius: 6px;
  padding: 7px 18px;
}
</style>
